module.exports = __webpack_public_path__ + "static/img/downloadCode.7f47c7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/components/nav-bar/components/img/downloadCode.png
// module id = M3ss
// module chunks = 9